'use client';

import { Box, Text, Heading } from "@chakra-ui/react";

export default function ContentBox({ children, padding = '4', gap = '0', text = false, align = 'left', fontSize = '1.8em', smallText = false }) {
  return (
    <Box p={{base: '0', lg: padding}} my={gap} rounded="lg" textAlign={align}>
      { text !== false && (
        <Heading
          as="h2"
          fontFamily="inherit"
          color="gray.600"
          fontWeight="700"
          fontSize={{ base: '1.8em', md: smallText ? '1.4em' : fontSize }}
          py={smallText ? '2' : '6'}
          pl="4"
          mb="8"
          borderLeft="4px solid"
          borderColor="orange.500"
          position="relative"
          overflow="hidden"
          _after={{
            content: '""',
            position: 'absolute',
            top: '50%',
            left: '0',
            width: '100%',
            height: '1px',
            background: 'gray.300',
            transition: 'transform 0.3s ease-in-out',
            transform: 'translateX("-50%")',
            zIndex: '1'
          }}
        >
          <Text bgColor="white" zIndex="2" position="relative" display="inline-block" px="2">
            { text }
          </Text>
        </Heading>
      )}

      { children }
    </Box>
  )
}
